import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {IDiagnosticOrder, IRevision} from '@ispm/test/interfaces/diagnostic-order.interface';
import {IWorkflow} from '@ispm/core/interfaces/workflow.interface';
import {InfoOrigin} from "@ispm/test/components/header-info/header-info.component";

@Component({
  selector: 'ispm-curation-navigation-pathway-execution',
  templateUrl: './curation-navigation-pathway-execution.component.html',
  styleUrls: ['./curation-navigation-pathway-execution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationNavigationPathwayExecutionComponent implements OnInit {
  @Input() currentTest: IDiagnosticOrder;
  @Input() currentWorkflow: IWorkflow;
  @Input() currentRevision: IRevision;
  @Input() newNotes: number;
  @Input() contextName: string;
  @Input() latestRevisionId: string;
  @Input() testInWorklist: boolean;
  @Input() infoOrigin: InfoOrigin;
  @Input() isPatientContext: boolean;

  pathwayActionsConfig: any = {};

  public disease: string;

  constructor() {
  }

  ngOnInit() {
    const diseaseName = (<any>this.currentTest).disease ? (<any>this.currentTest).disease.display + ' ' : '';
    this.disease = diseaseName + '(' + this.currentRevision.name + ')';
    this.buildPathwayActionsConfig();
  }

  private buildPathwayActionsConfig(): void {
    this.pathwayActionsConfig.contextName = this.contextName;
    this.pathwayActionsConfig.currentRevision = this.currentRevision;
    this.pathwayActionsConfig.currentTest = this.currentTest;
    this.pathwayActionsConfig.newNotes = this.newNotes;
    this.pathwayActionsConfig.currentWorkflow = this.currentWorkflow;
    this.pathwayActionsConfig.latestRevisionId = this.latestRevisionId;
    this.pathwayActionsConfig.testInWorklist = this.testInWorklist;
  }
}
